export const getMacaulayCatalogNumbers = (catalogNumbers?: string | number | null) => {
    if (!catalogNumbers) return [];

    return catalogNumbers
        .toString()
        .split(/[\s,;|]+/)
        .map(catalogNumber => catalogNumber.trim().replace(/^ML/i, ''))
        .filter(Boolean);
}

export const getMacaulayAssetUrl = (catalogNumber: string) => {
    return `https://macaulaylibrary.org/asset/${catalogNumber}`;
}
